// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
  --maxWidthDesktop: 27.625rem;
  --maxWidthTablet: 22.5rem;
  --maxWidthMobile: 15rem;
}

.placeholder-state {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
}

.placeholder-state__container {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    max-width: 15rem;
    text-align: center;
  }

.placeholder-state__icon {
    margin-bottom: calc(.5rem);
  }

.placeholder-state__illustration {
    display: none;
    place-items: center;
    margin-bottom: 1rem;
  }

.placeholder-state__illustration > * {
      grid-area: 1 / 1;
    }

.placeholder-state__illustration-blob {
    fill: #f6f7f8;
  }

.placeholder-state__body {
    display: flex;
    flex-direction: column;
    align-items: center;
  }

.placeholder-state__title {
    font-size: 1.125rem;
    line-height: 1.75rem;
    margin: 0 0 calc(.5rem) 0;
    font-weight: 700;
  }

.placeholder-state__content {
    display: flex;
    flex-direction: column;
    gap: calc(.5rem);
    align-items: center;
  }

.placeholder-state__message {
    margin: 0;
  }

.placeholder-state__actions {
    display: flex;
    flex-direction: column;
    gap: 1rem;
    align-items: center;
    margin-top: calc(.5rem);
  }

@media (width > 640px) {
      .placeholder-state--full-page .placeholder-state__container {
        max-width: 22.5rem;
      }

      .placeholder-state--full-page .placeholder-state__icon {
        width: 1.5rem;
        height: 1.5rem;
      }

      .placeholder-state--full-page .placeholder-state__title {
        font-size: 1.25rem;
        line-height: 1.875rem;
      }
    }

@media (width > 1024px) {
      .placeholder-state--full-page .placeholder-state__container {
        max-width: 27.625rem;
      }

        .placeholder-state--full-page .placeholder-state__container .placeholder-state__icon {
          display: none;
        }

      .placeholder-state--full-page .placeholder-state__illustration {
        display: grid;
      }

      .placeholder-state--full-page .placeholder-state__title {
        font-size: 1.5rem;
        line-height: 2.25rem;
      }
    }

.placeholder-state--medium .placeholder-state__container {
      max-width: 22.5rem;
    }

.placeholder-state--medium .placeholder-state__icon {
      width: 1.5rem;
      height: 1.5rem;
    }

.placeholder-state--medium .placeholder-state__title {
      font-size: 1.25rem;
      line-height: 1.875rem;
    }

.placeholder-state--small .placeholder-state__container {
      max-width: 15rem;
    }

.placeholder-state--small .placeholder-state__title {
      font-size: 1.125rem;
      line-height: 1.75rem;
    }

.placeholder-state--tiny .placeholder-state__container {
      flex-direction: row;
      gap: 1rem;
      align-items: center;
      max-width: none;
      text-align: left;
    }

.placeholder-state--tiny .placeholder-state__icon {
      margin-bottom: 0;
    }

.placeholder-state--tiny .placeholder-state__body {
      align-items: flex-start;
    }

.placeholder-state--tiny .placeholder-state__content,
    .placeholder-state--tiny .placeholder-state__actions {
      align-items: flex-start;
    }
`, ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
